import {usePostHog} from 'posthog-js/react';

const usePostHogHook = () => {
  const posthog = usePostHog();
  const identifyUser = user => {
    const organization_id = user?.organizations ? user?.organizations[0]?.id : null;
    const organization_name = user?.organizations ? user?.organizations[0]?.name : null;
    posthog.identify(user.id, {
      email: user.email,
      ...(organization_id && { organization_id }),
      ...(organization_name && { organization_name }),
    });
  };
  return {posthog, identifyUser};
};

export default usePostHogHook;
